/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {
    Button,
    CircularProgress,
    createStyles,
    Grid,
    makeStyles,
    Theme,
} from "@material-ui/core";

import React, { useContext } from "react";
import { UserContext } from "../../contexts/AppContext";
import { useHistory } from "react-router";
import { StepTwo } from "./components/FormSteps/StepTwo";
import { StepFour } from "./components/FormSteps/StepFour";
import { StepEight } from "./components/FormSteps/StepEight";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import announcePic from "../../images/announcePic.png";
import { Typography } from "@mui/material";
import {
    addressDefaultValue,
    announceInputsDefaultValue,
    HotelInputDefaultValue,
    locationDefaultValue,
    propertyInputsDefaultValue,
    propertyTypeInputsDefaultValue,
    propertyTypesDefaultValue,
} from "../../utils/defaultNullValues";
import {
    AnnounceInputs,
    IAddress,
    ILocation,
    IPropertyType,
    IPropertyTypeInputs,
    PropertyInputs,
} from "../../utils/AnnounceInterfaces";
import { StepThree } from "./components/FormSteps/StepThree";
import SessionHandler from "../../https/SessionHandler";
import { PropertyService } from "./services/PropertyService";
import { Error } from "@material-ui/icons";
import { colors } from "../../styles/defaultColors";
import {
    EAddressErrorMessages,
    EAnnounceErrorMessages,
    EPropertyErrorMessages,
    ERsttErrorMessages,
    EVehicleErrorMessages,
} from "../../utils/enum/properties";
import { useTranslation } from "react-i18next";
import { StepFive } from "./components/FormSteps/StepFive";
import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import { EAnnounceStatus } from "../../utils/enum";
import { HotelService } from "../Admin/Hotel/services/hotelService";
import { IHotel } from "../../utils/HotelInterface";
import { SortArray, useQuery } from "../../utils/App";
import { StepSix } from "./components/FormSteps/StepSix";
import { EPaymentMethod } from "../../utils/enum/PaymentMethod";
import { StepSeven } from "./components/FormSteps/StepSeven";
import { StepOne } from "./components/FormSteps/StepOne";
import { CountryPhoneList } from "../../utils/CountryList";
import moment from "moment";
import Spin from "../../images/Spin";
import { useParams } from "react-router-dom";
import MessageBrouillon from "../components/MessageBrouillon";
import { AnyAaaaRecord, AnyARecord } from "dns";
import { IPays, IVille } from "../../utils/DiversInterfaces";
import { villeDefaultValue } from "../../utils/defaultNullValues";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        properties: {
            width: "100%",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: {
                height: "auto",
            },
            marginBottom: 120,
        },
        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            [theme.breakpoints.down("xs")]: {
                width: "inherit",
            },
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans !important",
            color: "#890608",
            marginTop: "40px !important",
        },
        propertiesStepper: {
            width: "40%",
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                width: "70%",
            },
            [theme.breakpoints.down("xs")]: {
                justifyContent: "center",
            },
            "&.MuiPaper-root": {
                background: "none",
            },
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        showErrors: {},
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50,
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        mobile: {
            [theme.breakpoints.down("sm")]: {
                display: "none",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
            textTransform: "capitalize",
        },
        btn: {
            width: 180,
            height: 40,
            color: "#FFFFFF",
            textTransform: "initial",
            fontSize: 14,
            fontFamily: "Josefin Sans",
            marginBottom: 18,
            borderRadius: 100,
            background: "#890608",
            "&:hover": {
                background: "#EA7606",
            },
        },
        linkContainerButton: {
            textDecoration: "none",
        },
        ButtonPrevious: {
            textTransform: "capitalize",
            color: "#000000",
        },
        typo1: {
            fontSize: "1.5em",
            fontWeight: "bold",
            lineHeight: 28,
            fontFamily: "Josefin Sans",
            marginBottom: 32,
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        "@global": {
            ".MuiStepIcon-root.MuiStepIcon-active, .MuiStepIcon-root.MuiStepIcon-completed":
                {
                    color: "#890608",
                },
            ".MuiOutlinedInput-input": {
                padding: "9px 14px",
            },
        },
    })
);

function getSteps() {
    return [
        "Select campaign settings",
        "Create an ad",
        "Set geolocation",
        "Add photos",
        "create announce",
        "Add payment reference",
        "Interior rules",
        "Contact informations",
    ];
}

const countryService = new CountryService();
const propertyService = new PropertyService();
const hotelService = new HotelService();

export function AddAnnounceImmo() {
    const classes = styles();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const SearchTypeName= 'rstt';
     const isConnected = sessionHandler.isConnected;
        const userContext = useContext(UserContext);
        const { user, setUser } = userContext;
        const history = useHistory();
        const [activeStep, setActiveStep] = React.useState<number>(0);
        const [skipped, setSkipped] = React.useState(new Set<number>());
        const steps = getSteps();
        const [address, setAddress] = React.useState<IAddress>(addressDefaultValue);
        const [propertyType] = React.useState<IPropertyTypeInputs>(
            propertyTypeInputsDefaultValue
        );
        const [equipments, setEquipments] = React.useState<Array<string>>([]);
        const [equipmentsSelected, setEquipmentsSelected] = React.useState<any>([]);
        const [property, setProperty] = React.useState<PropertyInputs>(
            propertyInputsDefaultValue
        );
        const [propertyTypeList, setPropertyTypeList] = React.useState<
            IPropertyType[]
        >(propertyTypesDefaultValue);
    
        const [announce, setAnnounce] = React.useState<AnnounceInputs>({
            ...announceInputsDefaultValue,
            state: EAnnounceStatus.Submitted,
            owner: user._id,
        });
    
        const [propertyHotel] = React.useState<IHotel>(HotelInputDefaultValue);
    
        const [loading, setLoading] = React.useState(true);
        const [isSaving, setIsSaving] = React.useState(false);
        let errors: string[] = [];
        const [errorMessages, setErrorMessages] = React.useState<string>("");
        const [location, setLocation] =
            React.useState<ILocation>(locationDefaultValue);
        const { t } = useTranslation();
        const [paysList, setPaysList] = React.useState<any[]>();
        const [paysList1, setPaysList1] = React.useState<any[]>();
        const [paysSelected, setPaysSelected] = React.useState<any>([]);
        const [villeSelected, setVilleSelected] = React.useState<any>([]);
        const [hoteSelected, setHotelSelected] = React.useState<any>([]);
        const [hotel, setHotel] = React.useState<string>("");
        const [city, setVille] = React.useState<IVille | null>(null);
        const [choixHotel, setChoix] = React.useState<string>("");
        const [hotelList, setHotelList] = React.useState<any>([]);
        const [typeSelected, setTypeSelected] = React.useState<any>([]);
        const [selectedPaymentMethod, setSelectedPaymentMethod] =
            React.useState<any>([]);
        const [type, setType] = React.useState<string>("");
        const [paymentSelected, setPaymentSelected] = React.useState<any>([]);
        const [payment] = React.useState([]);
        const [checkedAnimaux, setCheckedAnimaux] = React.useState<any>(false);
        const [checkedEnfant, setCheckedEnfant] = React.useState<any>(false);
        const [jardin, setCheckedJardin] = React.useState<any>(false);
        const [checkedFetes, setCheckedFetes] = React.useState<any>(false);
        const [devise, setDevise] = React.useState("");
        const [codePhone, setCodePhone] = React.useState("");
        const [paypalAccount, setPaypalAccount] = React.useState<string[]>([]);
        const [orangeAccount, setOrangeAccount] = React.useState<string[]>([]);
        const [mtnAccount, setMtnAccount] = React.useState<string[]>([]);
        const [expressUnionAccount, setExpressUnionAccount] = React.useState<
            string[]
        >([]);
        const [checkin, setDispatchTime] = React.useState(moment());
        const [checkout, setDispatchTimeOut] = React.useState(moment());
        const [acceptConditions, setAcceptConditions] =
            React.useState<boolean>(false);
        const [priceWeeklyDaily, setPriceWeeklyDaily] = React.useState<number>(0);
        const [priceBiWeeklyDaily, setPriceBiWeeklyDaily] =
            React.useState<number>(0);
        const [priceMonthlyDaily, setPriceMonthlyDaily] = React.useState<number>(0);
        const [newPhotos, setNewPhotos] = React.useState<any>([]);
        const [draftedId, setDraftedId] = React.useState<string | null>(null);
        const [draftedAnnounceId, setDraftedAnnounceId] = React.useState<
            string | null
        >(null);
        const [loadingCountries, setLoadingCountries] = React.useState(true); 
    
        /************option remboursable**********************/
        const [valueGroup, setValueGroup] = React.useState('female');
    
        const handleChangeGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
            setValueGroup((event.target as HTMLInputElement).value);
            setAnnounce({
                ...announce,
                remboursable:(event.target as HTMLInputElement).value
            })
        };
        /********************************fin  option remboursable****************/
        enum Ebutton {
            Next = "next",
            Archive = "archive",
        }
    
        const params: { id: string } = useParams();
    
        const handleAcceptConditions = () => {
            setAcceptConditions(!acceptConditions);
        };
    
        const handleValueChange = (value: any) => {
            setDispatchTime(value);
        };
    
        const handleValueChangeOut = (value: any) => {
            setDispatchTimeOut(value);
        };
        const query = useQuery();
    
        React.useEffect(() => {
            if (params.id) {
                propertyService.getAnnounceByIdAdm(params.id).then((response) => {
                    setDraftedAnnounceId(params.id);
                    //console.log(response.data.activeStep)
                    
                    setProperty(response.data.property);
                    setAnnounce(response.data);
                    setPaypalAccount(response.data.account_paypal);
                    setActiveStep(response.data.activeStep);
                    const propertyType = propertyTypeList.find(
                        (item) => item._id === response.data.property.type._id
                    );
                    setTypeSelected(propertyType);
                    let checkedEquipments: string[] = [];
                    response.data.property.equipments.forEach((item: any) =>
                        checkedEquipments.push(item._id)
                    );
                    setEquipments(checkedEquipments);
                    const country = paysList?.find(
                        (item) =>
                            item.name === response.data.property.address.country?.name
                    );
                    if (country) {
    
                        setPaysSelected(country);
                        setAddress(response.data.property.address);
                        const city = country?.villes.find(
                            (item: any) =>
                                item.name === response.data.property.address.city
                        );
                        setVilleSelected(city);
                    }
                    setLocation({
                        latitude: response.data.property.location.latitude,
                        longitude: response.data.property.location.longitude,
                    });
                    setCheckedAnimaux(response.data.animaux);
                    setCheckedEnfant(response.data.enfant);
                    setCheckedFetes(response.data.fetes);
                    setDispatchTime(moment(response.data.checkin));
                    setDispatchTimeOut(moment(response.data.checkout));
                    setPriceWeeklyDaily(Number(response.data.priceWeekly / 7));
                    setPriceBiWeeklyDaily(Number(response.data.priceBiWeekly / 14));
                    setPriceMonthlyDaily(Number(response.data.priceMonthly / 30));
                });
            }
        }, [params.id, paysList, propertyTypeList, draftedAnnounceId]);
    
    
        React.useEffect(() => {
                // Fetch countries with populated 'villes' field
                setLoadingCountries(true); // Start loading
                countryService.getAllCountries()
                    .then((response: { success: boolean; data: IPays[] }) => {
                        if (response.success) {
                            setPaysList(response.data);
                        } else {
                            console.error("Failed to fetch countries");
                        }
                    })
                    .catch((err) => {
                        console.error("Error fetching countries:", err);
                    })
                    .finally(() => {
                        setLoadingCountries(false); // Stop loading
                    });
            }, []);
    
    
        React.useEffect(() => {
            if (!user.email) {
                isConnected()
                    .then((response: any) => {
                        if (response.success) {
                            setUser(response.data);
                            setAnnounce({
                                ...announce,
                                owner: response.data._id,
                            });
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                        history.push("/");
                    });
            } else {
                setLoading(true);
                propertyService
                    .getAllPropertyTypes()
                    .then((response) => {
                        if (response.success) {
                            setPropertyTypeList(
                                response.data.filter(
                                    (val: any) =>
                                        val.name !== "Hôtel" 
                                        // &&
                                        // val.name !== "Appartement"
                                )
                            );
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            }
        }, [user, history, isConnected, setUser]);
    
        const isStepSkipped = (step: number) => {
            return skipped.has(step);
        };
    
        React.useEffect(() => {
            setProperty({
                ...property,
                location,
            });
        }, [location]);
    
        React.useEffect(() => {
            setDevise(
                CountryPhoneList.filter(
                    (devi: any) =>
                        devi.name?.toLowerCase() === address.country?.name?.toLowerCase()
                )[0]?.currencyCode
            );
        }, [address]);
    
        React.useEffect(() => {
            setCodePhone(
                CountryPhoneList.filter(
                    (devi: any) =>
                        devi.name?.toLowerCase() === address.country?.name?.toLowerCase()
                )[0]?.dial_code
            );
        }, [address]);
    
        
    
        const handleBack = () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        };
    
        const onChangeHandler = (event: any): void => {
            setProperty({ ...property, [event.target.name]: event.target.value });
        };
    
        const onChangePropertyType = (value: any): void => {
            setTypeSelected(value);
    
            if (value != null) {
                setChoix(value.name);
                setType(value._id);
            }
        };
        React.useEffect(() => {
            setProperty({
                ...property,
                owner: user._id,
                type,
            });
        }, [type]);
    
        let tabPaypal: any = [];
        let tabBancare: any = [];
        let tabMobile: any = [];
        for (let i in payment) {
            if (payment[i] === EPaymentMethod.Paypal) {
                if (user.payments.paypal.length !== 0) {
                    user.payments.paypal.forEach((paypl) => {
                        tabPaypal.push({
                            payement: "Paypal",
                            label:
                                paypl.recepient_email ||
                                paypl.recepient_paypal_id ||
                                paypl.recepient_phone,
                            value: paypl._id || "",
                        });
                    });
                }
            } else if (payment[i] === EPaymentMethod.Orange) {
                if (user.payments.mobileMoney.length !== 0) {
                    user.payments.mobileMoney.forEach((mm) => {
                        tabMobile.push({
                            payement: "Orange",
                            label: mm.mobile_number,
                            value: mm._id || " ",
                        });
                    });
                }
            } else if (payment[i] === EPaymentMethod.MTN) {
                if (user.payments.mobileMoney.length !== 0) {
                    user.payments.mobileMoney.forEach((mm) => {
                        tabMobile.push({
                            payement: "MTN",
                            label: mm.mobile_number,
                            value: mm._id || " ",
                        });
                    });
                }
            } else if (payment[i] === EPaymentMethod.Nexttel) {
                if (user.payments.mobileMoney.length !== 0) {
                    user.payments.mobileMoney.forEach((mm) => {
                        tabMobile.push({
                            payement: "Nexttel",
                            label: mm.mobile_number,
                            value: mm._id || " ",
                        });
                    });
                }
            } else if (payment[i] === EPaymentMethod.ExpressUnion) {
                if (user.payments.mobileMoney.length !== 0) {
                    user.payments.mobileMoney.forEach((mm) => {
                        tabMobile.push({
                            payement: "ExpressUnion",
                            label: mm.mobile_number,
                            value: mm._id || " ",
                        });
                    });
                }
            } else if (payment[i] === EPaymentMethod.YUP) {
                if (user.payments.mobileMoney.length !== 0) {
                    user.payments.mobileMoney.forEach((mm) => {
                        tabMobile.push({
                            payement: "YUP",
                            label: mm.mobile_number,
                            value: mm._id || " ",
                        });
                    });
                }
            }
        }
        let tabResult = tabPaypal.concat(tabBancare, tabMobile);
        const onChangePaymentMethod = (values: any): void => {
            setSelectedPaymentMethod(values);
            setAnnounce({
                ...announce,
            });
        };
    
        const onChangeAddress = (event: any): void => {
            const { name, value } = event.target;
        
            if (name === "devise" || name === "codePhone") {
                // Update the announce state for these fields
                setAnnounce((prevAnnounce) => ({
                    ...prevAnnounce,
                    [name]: value,
                }));
            } else {
                // Update address and property for other fields
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    [name]: value,
                }));
                setProperty((prevProperty) => ({
                    ...prevProperty,
                    address: {
                        ...prevProperty.address,
                        [name]: value,
                    },
                }));
            }
        };
        
        React.useEffect(() => {
            setProperty({
                ...property,
                address,
            });
        }, [address]);
        const onChangeAnnounce = (event: any): void => {
            setAnnounce({ ...announce, [event.target.name]: event.target.value });
        };
    
        const onChangeSpecialPriceAnnounce = (event: any): void => {
            switch (event.target.name) {
                case "priceWeeklyDaily": {
                    setPriceWeeklyDaily(event.target.value);
                    setAnnounce({
                        ...announce,
                        priceWeekly: event.target.value * 7,
                    });
                    break;
                }
                case "priceBiWeeklyDaily": {
                    setPriceBiWeeklyDaily(event.target.value);
                    setAnnounce({
                        ...announce,
                        priceBiWeekly: event.target.value * 14,
                    });
                    break;
                }
                case "priceMonthlyDaily": {
                    setPriceMonthlyDaily(event.target.value);
                    setAnnounce({
                        ...announce,
                        priceMonthly: event.target.value * 30,
                    });
                    break;
                }
                case "priceWeekly": {
                    setAnnounce({ ...announce, priceWeekly: event.target.value });
                    setPriceWeeklyDaily(
                        Number(
                            (event.target.value / 7).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        )
                    );
                    break;
                }
                case "priceBiWeekly": {
                    setAnnounce({ ...announce, priceBiWeekly: event.target.value });
                    setPriceBiWeeklyDaily(
                        Number(
                            (event.target.value / 14).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        )
                    );
                    break;
                }
                case "priceMonthly": {
                    setAnnounce({ ...announce, priceMonthly: event.target.value });
                    setPriceMonthlyDaily(
                        Number(
                            (event.target.value / 30).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        )
                    );
                    break;
                }
            }
        };
    
        const handleOnChangeSelect = (key: string, v: string) => {
            setAnnounce({ ...announce, [key]: v });
        };
        /*************choix de option remboursable*******************/
        React.useEffect(()=>{
            if(valueGroup==="noremboursable"){
                setAnnounce({
                    ...announce,
                    freeRefundDay:0,
                    penaltyDayFees:0,
                    penaltyDayFeesAfterBookingStarted:0
                })
            }else if(valueGroup==="remboursable"){
                setAnnounce({
                    ...announce,
                    notRemboursable1:0,
                })
            }
        },[valueGroup])
        /**** */
    
        const onChangeSuperOffer = (event: React.ChangeEvent<HTMLInputElement>) => {
            setAnnounce({ ...announce, superOffer: event.target.checked ? 1 : 0 });
        };
    
        const onChangeEquipments = (value: any): void => {
            setEquipmentsSelected(value);
            const ids: string[] = value.map((value: any) => value._id);
            setEquipments(ids);
        };
        React.useEffect(() => {
            setProperty({
                ...property,
                equipments,
            });
        }, [equipments]);
    
        React.useEffect(() => {
            hotelService
                .getHotelByUser(user._id)
                .then((response: any) => {
                    if (response.success) {
                        setHotelList(response.hotel);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                });
        }, [setLoading, setHotelList]);
    
        const onChangePhoto = (photos: any) => {
            if (params.id) {
                setNewPhotos(photos);
                // setProperty({
                //     ...property,
                //     photos: [ ...property.photos, newPhotos],
                //     address,
                // });
            } else {
                setNewPhotos(photos);
                // setProperty({
                //     ...property,
                //     photos: [...photos],
                // });
            }
        };
    
        const onChangeLocation = (longitude: number, latitude: number): void => {
            setLocation({ longitude, latitude });
        };


        const invalidCountry: IPays = {
                    _id: '', // Default or placeholder ID
                    name: 'Invalid Country', // Placeholder name
                    nomFR: 'Pays invalide', // Placeholder French name
                    nomEN: 'Invalid Country', // Placeholder English name
                    status: false, // Default status
                    currencyCode: '', // Placeholder currency code
                    villes: [], // Empty array for cities
                    // Optional fields can be left undefined or filled with placeholders if necessary
                    photo: undefined,
                    countryId: undefined,
                    registeredTaxName: undefined,
                    taxReference: undefined,
                    businessType: undefined,
                    postalAdress: undefined,
                    officeNumbers: undefined,
                    phoneCode: undefined,
                };

                const invalidCity: IVille = {
                        _id: '', // Default empty ID
                        count: '0', // Placeholder count
                        name: 'Invalid City', // Default name
                        nomFR: 'Ville invalide', // Optional
                        nomEN: 'Invalid City', // Optional
                        quartiers: [], // Optional
                    };        


        const onChangePays = (value: any): void => {
            if (value) {
                setPaysSelected(value);
        
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    country: value,
                }));
        
                setProperty((prevProperty) => ({
                    ...prevProperty,
                    address: {
                        ...prevProperty.address,
                        country: value,
                    },
                }));
        
                // Update announce directly
                setAnnounce((prevAnnounce) => ({
                    ...prevAnnounce,
                    devise: value.currencyCode || "XAF",
                    codePhone: value.phoneCode || "",
                }));
            } else {
                // Handle null value (country deselected)
                setPaysSelected(null);
        
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    country: invalidCountry,
                }));
        
                setProperty((prevProperty) => ({
                    ...prevProperty,
                    address: {
                        ...prevProperty.address,
                        country: invalidCountry,
                    },
                }));
        
        
                // Clear from announce
                setAnnounce((prevAnnounce) => ({
                    ...prevAnnounce,
                    devise: "",
                    codePhone: "",
                }));
            }
        };
     
        
    
       
    
        let tab: any = [];
    
        if (paysList && paysList.length > 0) {
            paysList.forEach((pays: any) => {
                //console.log('Inspecting pays:', pays._id); // Log each country being inspected
                if (pays?._id === address.country?._id) {
                    //console.log(`Match found for country: ${pays._id}`); // Log if country matches
                    if (pays.villes && pays.villes.length > 0) {
                        pays.villes.forEach((vil: any) => {
                            //console.log('Adding city to tab:', vil); // Log each city being added
                            tab.push(vil);
                        });
                    } else {
                        //console.log(`No villes found for country: ${pays._id}`); // Log if no cities exist
                        //console.log('pays._id:', pays._id)
                    }
                } else {
                   //console.log(`No match for country: ${pays._id}`); // Log if country doesn't match
                }
            });
        } else {
            //console.log('PaysList is empty or undefined.'); // Log if paysList is not populated
        }
    
        const onChangeVille = (value: any): void => {
            //console.log("Selected city:", value); // Log the selected city
        
            if (value) {
                setVilleSelected(value); // Keep track of selected city
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    city: value, // Save the full object, not just the name
                }));
                setProperty((prevProperty) => ({
                    ...prevProperty,
                    address: {
                        ...prevProperty.address,
                        city: value, // Update property.address with full city object
                    },
                }));
            } else {
                // Handle case where value is null (e.g., deselected city)
                setVilleSelected(null);
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    city: invalidCity,
                }));
                setProperty((prevProperty) => ({
                    ...prevProperty,
                    address: {
                        ...prevProperty.address,
                        city: invalidCity,
                    },
                }));
            }
        };
    
    
        const onChangeHotel = (value: any): void => {
            setHotelSelected(value);
            if (value != null) {
                setHotel(value._id);
            }
        };
    
        React.useEffect(() => {
            setProperty({
                ...property,
                hotel,
            });
        }, [hotel]);
    
        /*reglement interne*/
        const handleChangeCheckedAnimaux = (v: any) => {
            setCheckedAnimaux(v);
        };
        const handleChangeCheckedEnfant = (v: any) => {
            setCheckedEnfant(v);
        };
        const handleChangeCheckedFetes = (v: any) => {
            setCheckedFetes(v);
        };
        const handleChangeCheckedJardin = (v: any) => {
            setCheckedJardin(v.target.checked);
        };
        React.useEffect(() => {
            setProperty({
                ...property,
                jardin: jardin,
            });
        }, [jardin]);
        React.useEffect(() => {
            setAnnounce({
                ...announce,
                animaux: checkedAnimaux,
                enfant: checkedEnfant,
                fetes: checkedFetes,
            });
        }, [
            checkedAnimaux,
            checkedEnfant,
            checkedFetes,
            address,
        ]);
    
        React.useEffect(() => {
            setAnnounce({
                ...announce,
                checkin: checkin,
                checkout: checkout,
            });
        }, [checkin, checkout]);
    
        React.useEffect(() => {
            setAddress({
                ...address,
                city: city || invalidCity,
            });
        }, [city]);
    
        React.useEffect(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
        }, [])
    

    const handleNext = () => {
        let newSkipped = skipped;
        if (query.get("ajout") === "exist") {
            setType(
                propertyTypeList.filter((val: any) => val.name === "Hôtel")[0]
                    ._id
            );
        }
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        let showNextStep = true;
        if (activeStep === 0) {
            showNextStep = isRsttValidate(property, propertyType);
        } else if (activeStep === 1) {
            showNextStep = isAdressValidate(address);
        } else if (activeStep === 3) {
            showNextStep = isPhotosValidate(property);
        } else if (activeStep === 4) {
            showNextStep = isAnnounceValidate(announce);
        } else if (activeStep === 5) {
            showNextStep = isAnnounceStepSix(announce, property);
        }

        if (showNextStep) {
            errors = [];
            setErrorMessages("");

            
            handleArchive(Ebutton.Next);
            if (!params.id && draftedAnnounceId){
                setLoading(true)
                setTimeout(() => {
                    history.push(`add/${draftedAnnounceId}`)
                    setLoading(false)
                }, 1000);
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        } else {
            showErrorsMessages();
        }
    };

    const actualStepForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <StepOne
                        handleChangePropertyType={onChangePropertyType}
                        handleChange={onChangeHandler}
                        onChangeHotel={onChangeHotel}
                        values={property}
                        hotelList={hotelList}
                        hoteSelected={hoteSelected}
                        propertyTypeValues={propertyType}
                        propertyHotel={propertyHotel}
                        onChangeMultiSelect={onChangeEquipments}
                        propertyTypeList={propertyTypeList}
                        equipmentsSelected={equipmentsSelected}
                        typeSelected={typeSelected}
                        choixHotel={choixHotel}
                        handleChangeCheckedJardin={handleChangeCheckedJardin}
                        setEquipments={setEquipments}
                        equipments={equipments}
                        searchTypeName={SearchTypeName}
                    />
                    
                );
            case 1:
                return (
                    <StepTwo
                        handleChange={onChangeAddress}
                        values={address}
                        onChangeMultiSelect={onChangePays}
                        paysSelected={paysSelected}
                        paysList={paysList}
                        country={address.country}
                        onChangeVille={onChangeVille}
                        villeSelected={villeSelected}
                        tab={tab}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 2:
                return (
                    <StepThree
                        handleChange={onChangeLocation}
                        values={location}
                        handleNext={handleNext}
                        autoGeolocate={!params.id}
                        startLongitude={
                            location.latitude !== 0 && location.longitude !== 0
                                ? location.longitude
                                : 19.13697660832946
                        }
                        startLatitude={
                            location.latitude !== 0 && location.longitude !== 0
                                ? location.latitude
                                : -1.2138498098141102
                        }
                        searchTypeName={SearchTypeName}
                    />
                );
            case 3:
                return (
                    <StepFour
                        handleChangePhotos={onChangePhoto}
                        values={property}
                        propertyId={property._id || draftedId!}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 4:
                return (
                    <StepFive
                        handleChange={onChangeAnnounce}
                        handleChangeSpecialPrice={onChangeSpecialPriceAnnounce}
                        handleSuperOffer={onChangeSuperOffer}
                        address={address}
                        devise={devise}
                        values={announce}
                        propertyTypeValues={propertyType}
                        priceWeeklyDaily={priceWeeklyDaily}
                        priceBiWeeklyDaily={priceBiWeeklyDaily}
                        priceMonthlyDaily={priceMonthlyDaily}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 5:
                return (
                    <StepSix
                        country={address.country}
                        handleChange={onChangeAnnounce}
                        handleOnChange={handleOnChangeSelect}
                        values={announce}
                        handleChangePaymentMethod={onChangePaymentMethod}
                        setPaypalAccount={setPaypalAccount}
                        paypalAccount={paypalAccount}
                        setOrangeAccount={setOrangeAccount}
                        orangeAccount={orangeAccount}
                        setMtnAccount={setMtnAccount}
                        mtnAccount={mtnAccount}
                        setExpressUnionAccount={setExpressUnionAccount}
                        expressUnionAccount={expressUnionAccount}
                        paymentSelected={paymentSelected}
                        codePhone={codePhone}
                        valueGroup={valueGroup}
                        handleChangeGroup={handleChangeGroup}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 6:
                return (
                    <StepSeven
                        handleChange={onChangeAnnounce}
                        values={announce}
                        handleChangeCheckedAnimaux={handleChangeCheckedAnimaux}
                        handleChangeCheckedEnfant={handleChangeCheckedEnfant}
                        handleChangeCheckedFetes={handleChangeCheckedFetes}
                        checkedAnimaux={checkedAnimaux}
                        checkedEnfant={checkedEnfant}
                        checkedFetes={checkedFetes}
                        checkin={checkin}
                        checkout={checkout}
                        handleValueChange={handleValueChange}
                        handleValueChangeOut={handleValueChangeOut}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 7:
                return (
                    <StepEight
                        values={announce}
                        acceptConditions={acceptConditions}
                        handleChange={onChangeAnnounce}
                        handleAcceptConditions={handleAcceptConditions}
                        searchTypeName={SearchTypeName}
                    />
                );
            // never forget the default case, otherwise VS code would be mad!
            default:
            // do nothing
        }
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY TYPE ANNONCE") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyTypeAnnonce}`);
            } else if (error === "EMPTY NAME") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyRsttName}`);
            } /* else if (error === "EMPTY NUMBER OF BEDROOMS") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyNumberOfBedrooms}`);
            } else if (error === "EMPTY NUMBER OF BATHROOMS") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyNumberOfBathrooms}`);
            } else if (error === "EMPTY SURFACE HABITABLE") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptySurfaceHabitable}`);
            } else if (error === "EMPTY SUPERFICIE TERRAIN") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptySuperficieTerrain}`);
            } else if (error === "EMPTY YEAR BUILT") {
                allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyYearBuilt}`);
            }*/
        });
        setErrorMessages(allErrorMessages.substring(1, allErrorMessages.length));
    };
    
    

    const isRsttValidate = (values: PropertyInputs, type: IPropertyTypeInputs): boolean => {
        errors = [];
    
        if (!values.rstt_typeAnnonce || values.rstt_typeAnnonce.trim() === "") {
            errors.push("EMPTY TYPE ANNONCE");
        }
       
    
        return !Boolean(errors.length);
    };
    
    
    // console.log("anoooce",announce)
    const isAdressValidate = (values: IAddress): boolean => {
        if (!values.city || !values.city._id) {
            if (!errors.includes("EMPTY CITY")) errors.push("EMPTY CITY");
        } 
        return errors.length === 0;
    };


    const isAnnounceValidate = (values: AnnounceInputs): boolean => {
        if (values.description === "") {
            if (!errors.includes("EMPTY DESCRIPTION"))
                errors = [...errors, "EMPTY DESCRIPTION"];
        } else if (values.price === 0) {
            if (!errors.includes("EMPTY PRICE"))
                errors = [...errors, "EMPTY PRICE"];
        }
        return !Boolean(errors.length);
    };

    const isPhotosValidate = (values: PropertyInputs): boolean => {
        if (newPhotos?.length < 5 && property.photos?.length < 5) {
            if (!errors.includes("INSUFFICIENT PICTURES"))
                errors = [...errors, "INSUFFICIENT PICTURES"];
        }
        return !Boolean(errors.length);
    };

    const isAnnounceStepSix = (
        values: AnnounceInputs,
        property: PropertyInputs
    ): boolean => {
        if (
            property.address.country?.name === "Cameroon" &&
            values.favoritePaymentMethod === ""
        ) {
            if (!errors.includes("EMPTY PREFERRED METHOD"))
                errors = [...errors, "EMPTY PREFERRED METHOD"];
        } else if (
            property.address.country?.name === "Cameroon" &&
            values.favoritePaymentMethod !== ""
        ) {
            if (
                values.favoritePaymentMethod === EPaymentMethod.Orange &&
                values.account_orange === ""
            ) {
                if (!errors.includes("EMPTY ORANGE ACCOUNT"))
                    errors = [...errors, "EMPTY ORANGE ACCOUNT"];
            }
            if (
                values.favoritePaymentMethod === EPaymentMethod.MTN &&
                values.account_mtn === ""
            ) {
                if (!errors.includes("EMPTY MTN ACCOUNT"))
                    errors = [...errors, "EMPTY MTN ACCOUNT"];
            }

        } else if (values.penaltyDayFees === 0 && values.remboursable==="remboursable") {
            if (!errors.includes("NULL PENALTY"))
                errors = [...errors, "NULL PENALTY"];
        }
        return !Boolean(errors.length);
    };

    const isAnnounceStepEight = (values: AnnounceInputs): boolean => {
        if (values.contactName === "") {
            if (!errors.includes("EMPTY CONTACT NAME"))
                errors = [...errors, "EMPTY CONTACT NAME"];
        } else if (values.contactPhone === "") {
            if (!errors.includes("EMPTY CONTACT PHONE"))
                errors = [...errors, "EMPTY CONTACT PHONE"];
        } else if (values.howToAccessDesc === "") {
            if (!errors.includes("EMPTY LOCATION DESCRIPTION"))
                errors = [...errors, "EMPTY LOCATION DESCRIPTION"];
        }
        return !Boolean(errors.length);
    };

    const handleSubmit = () => {
        if (isAnnounceStepEight(announce)) {
            setIsSaving(true);
            errors = [];
            setErrorMessages("");
            propertyService
                .updatePropertyById(
                    property._id
                        ? property
                        : { ...property, _id: draftedId!, hotel: null }
                )
                .then((response) => {
                    if (response.success === true) {
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    _id: draftedAnnounceId!,
                                    state: EAnnounceStatus.Submitted,
                                    activeStep,
                                },
                                property._id || draftedId!
                            )
                            .then((response) => {
                                if (response.success) {
                                    history.push("/announces");
                                }
                                setIsSaving(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                console.log(
                                    "create property(annouce) component err",
                                    error
                                );
                                setLoading(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                showErrorsMessages();
                            });
                    }
                })
                .catch((error) => {
                    setIsSaving(false);
                    showErrorsMessages();
                });
        } else {
            showErrorsMessages();
        }
    };

    let tabPhot: any = [];
    property.photos?.forEach((pho: any) => {
        if (pho.filename !== undefined) {
            tabPhot.push(pho);
        }
    });

    const handleArchive = (button: string) => {
        // setIsSaving(true);
        errors = [];
        setErrorMessages("");
        if (property.address) {
            if (property.address.city && typeof property.address.city === 'object') {
                const cityId = property.address.city?._id || null; // Extract _id
                (property.address.city as any) = cityId; // Type assertion to bypass the type error
            }
            if (property.address.country && typeof property.address.country === 'object') {
                const countryId = property.address.country?._id || null; // Extract _id
                (property.address.country as any) = countryId; // Type assertion to bypass the type error
            }
        }
        // let _propertyId: String = "";
        if (!params.id && !draftedId) {
            delete property.photos;
            propertyService
                .saveProperty(property)
                .then((response) => {
                    if (response.success === true) {
                        // _propertyId = response.property._id;
                        setDraftedId(response.property._id);
                        if (property.photos && property.photos.length) {
                            property.photos.forEach(
                                (photo: any, index: number) => {
                                    let formData = new FormData();
                                    formData.append(`photo`, photo);
                                    propertyService
                                        .savePropertyPhotosById(
                                            response.property._id,
                                            formData
                                        )
                                        .then((response) => {
                                            if (response.success)
                                                propertyService
                                                    .getPropertyById(draftedId!)
                                                    .then((response) => {
                                                        if (response.success)
                                                            setProperty(
                                                                response.data
                                                            );
                                                    });
                                        })
                                        .finally(() => {
                                            setNewPhotos([]);
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            );
                        }
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    state: EAnnounceStatus.Drafted,
                                    activeStep:
                                        button === Ebutton.Next
                                            ? activeStep + 1
                                            : activeStep,
                                },
                                response.property._id
                            )
                            .then((response) => {
                                if (response.success) {
                                    // setAnnounce(response.announce);
                                    setDraftedAnnounceId(response.announce._id);
                                    if (button === Ebutton.Archive)
                                        history.push("/announces");
                                }
                                setIsSaving(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                console.log(error);
                            });
                    }
                })
                .catch((error) => {
                    setIsSaving(false);
                    showErrorsMessages();
                });
        } else {
            let tabPhotos: any = [];
            property.photos?.forEach((pho: any) => {
                if (pho.filename !== undefined) {
                    tabPhotos.push(pho);
                }
            });
            propertyService
                .updatePropertyById(
                    property._id
                        ? property
                        : { ...property, _id: draftedId!, hotel: null }
                )
                .then((response) => {
                    if (response.success === true) {
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    state: EAnnounceStatus.Drafted,
                                    _id: draftedAnnounceId!,
                                    activeStep:
                                        button === Ebutton.Next
                                            ? activeStep + 1
                                            : activeStep,
                                },
                                property._id || draftedId!
                            )
                            .then((response) => {
                                if (response.success) {
                                    // setAnnounce(response.announce);
                                }
                            })
                            .catch((error) => {
                                console.log(
                                    "edit property(annouce) component err",
                                    error
                                );
                                setLoading(false);
                            });
                        if (newPhotos && newPhotos.length && activeStep === 3) {
                            newPhotos.forEach((photo: any) => {
                                let formData = new FormData();
                                formData.append(`photo`, photo);
                                if (property._id || draftedId) {
                                    propertyService
                                        .savePropertyPhotosById(
                                            property._id ?? draftedId!,
                                            formData
                                        )
                                        .then((response) => {
                                            if (response.success) {
                                                propertyService
                                                    .getPropertyById(draftedId!)
                                                    .then((response) => {
                                                        if (response.success)
                                                            setProperty(
                                                                response.data
                                                            );
                                                    });
                                                if (button === Ebutton.Archive)
                                                    history.push("/announces");
                                            }
                                        })
                                        .finally(() => {
                                            setNewPhotos([]);
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            if (button === Ebutton.Archive)
                                                history.push("/announces");
                                            setLoading(false);
                                        });
                                }
                            });
                        } else {
                            if (button === Ebutton.Archive)
                                history.push("/announces");
                        }
                    }
                })
                .catch((error) => {
                    console.log("update property", error);
                    setLoading(false);
                    showErrorsMessages();
                });
        }
    };

    const handleCancel = () => {
        history.push("/announces");
    };

    return (
        <div className={classes.properties}>
            <Grid container direction="column">
                <Grid item className={classes.propertiesHeader}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {activeStep === 5
                            ? t("annonce.title.creezVotreAnnonce")
                            : t("propriete.title.decrivezVotreVehicule")}
                    </Typography>
                    <Stepper
                        activeStep={activeStep}
                        className={classes.propertiesStepper}
                    >
                        {steps.map((label, index) => {
                            const stepProps: { completed?: boolean } = {};
                            const labelProps: { optional?: React.ReactNode } =
                                {};
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>
                                        {/* {label} */}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Grid>
                <Grid>
                    <MessageBrouillon />
                </Grid>
                <Grid
                    item
                    container
                    spacing={3}
                    justifyContent="center"
                    direction="row"
                >
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                        className={classes.mobile}
                    >
                        <img src={announcePic} alt="Announce illustration" />
                    </Grid>

                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className={classes.propertiesCheck}
                    >
                        {loading ? (
                            <CircularProgress
                                size={32}
                                style={{ color: "#890608" }}
                            />
                        ) : (
                            <>
                                <div className={classes.propertiesCheckbox}>
                                    {actualStepForm()}
                                    <div className={classes.showErrors}>
                                        {errorMessages && (
                                            <div className={classes.errors}>
                                                <Typography>
                                                    <Error />
                                                    <br />
                                                    <span>{errorMessages}</span>
                                                </Typography>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {activeStep < steps.length && (
                                    <div className={classes.propertiesBtn}>
                                        <Button
                                            onClick={
                                                activeStep === 0
                                                    ? handleCancel
                                                    : handleBack
                                            }
                                            className={classes.ButtonPrevious}
                                        >
                                            {activeStep === 0
                                                ? t("propriete.buttonCancel")
                                                : t("propriete.buttonPrevious")}
                                        </Button>
                                        <div>
                                            <Button
                                                className={classes.Button}
                                                onClick={() =>
                                                    handleArchive(
                                                        Ebutton.Archive
                                                    )
                                                }
                                            >
                                                {t("propriete.buttonArchiver")}
                                            </Button>
                                            <Button
                                                disabled={
                                                    (activeStep ===
                                                        steps.length - 1 &&
                                                        isSaving) ||
                                                    (activeStep ===
                                                        steps.length - 1 &&
                                                        !acceptConditions)
                                                }
                                                onClick={
                                                    activeStep ===
                                                    steps.length - 1
                                                        ? handleSubmit
                                                        : handleNext
                                                }
                                                endIcon={
                                                    activeStep ===
                                                        steps.length - 1 &&
                                                    isSaving ? (
                                                        <Spin />
                                                    ) : null
                                                }
                                                className={classes.Button}
                                            >
                                                {activeStep === steps.length - 1
                                                    ? `${t(
                                                          "propriete.buttonValidate"
                                                      )}`
                                                    : `${t(
                                                          "propriete.buttonNext"
                                                      )}`}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}
